import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type DealerBookingCodeDataFragment = (
  { __typename: 'DealerBookingCodeSetting' }
  & Pick<SchemaTypes.DealerBookingCodeSetting, 'viewable'>
  & { overrides: Array<(
    { __typename: 'DealerBookingCodeSettingOverride' }
    & Pick<SchemaTypes.DealerBookingCodeSettingOverride, 'dealerId' | 'viewable'>
  )> }
);

export const DealerBookingCodeDataFragmentDoc = /*#__PURE__*/ gql`
    fragment DealerBookingCodeData on DealerBookingCodeSetting {
  viewable
  overrides {
    dealerId
    viewable
  }
}
    `;